import React from 'react';
import styled from 'styled-components';

const GalleryContainer = styled.div`
  margin: 3rem 0;
`;

const GalleryTitle = styled.h3`
  font-size: 1.8rem;
  color: ${({ theme }) => theme.colors.greenPrimary};
  margin-bottom: 2rem;
  text-align: center;
`;

const GalleryGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 2rem;
  margin: 2rem 0;
`;

const ImageCard = styled.div`
  position: relative;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 4px 6px rgba(0,0,0,0.1);
  aspect-ratio: 16/9;
`;

const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;

  ${ImageCard}:hover & {
    transform: scale(1.05);
  }
`;

const ImageCaption = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.7);
  color: white;
  padding: 0.5rem;
  font-size: 0.9rem;
  text-align: center;
`;

const ImageGallery = ({ title, images }) => {
  return (
    <GalleryContainer>
      <GalleryTitle>{title}</GalleryTitle>
      <GalleryGrid>
        {images.map((image, index) => (
          <ImageCard key={index}>
            <Image src={image.url} alt={image.caption} loading="lazy" />
            <ImageCaption>{image.caption}</ImageCaption>
          </ImageCard>
        ))}
      </GalleryGrid>
    </GalleryContainer>
  );
};

export default ImageGallery;
